exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basePage[data-v-0618fdfa]{height:100%;width:100%;margin:0;padding:0;position:relative}.cmp_list_cla[data-v-0618fdfa] .device_num_cla{color:#4db22f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0618fdfa","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/tenantManager/companyInfo/companyList.vue
// module id = JsDV
// module chunks = 6